<template>
  <div>
    <cooperation-search-head
      :titleInfo="titleInfo"
      :bgUrl="bgUrl"
      @handSearch="handSearch"
      :companyList="companyList"
      :showDropSelect="true"
    >
    </cooperation-search-head>
    <div class="cooperation-accounts-index-container">
      <div class="accounts-content-head">
        <cooperation-title-cp
          title="结算概览"
          :bg="false"
        ></cooperation-title-cp>
        <div class="visa-details-container">
          <div class="top">
            <div>
              <span></span>
              <span
                >{{ body.contractSum || '--' }}&nbsp;<span
                  v-if="body.contractSum != null"
                  >份</span
                ></span
              >
              <span>合同数量</span>
            </div>
            <div>
              <span></span>
              <span
                >{{ body.hjContractSum || '--' }}&nbsp;<span
                  v-if="body.hjContractSum != null"
                  >份</span
                ></span
              >
              <span>已结算合同数</span>
            </div>
          </div>
          <div class="bottom">
            <div>
              <span></span>
              <span>{{ body.contractSignsum | money2 }}</span>
              <span>合同签约总额</span>
            </div>
            <div>
              <span></span>
              <span>{{ body.hjContractAmount | money2 }}</span>
              <span>合同结算金额</span>
            </div>
            <!-- <div>
              <span></span>
              <span>{{ body.hjAdjustmentAmount | money2 }}</span>
              <span>结算调整金额</span>
            </div> -->
          </div>
        </div>
      </div>
      <div class="accounts-body-content">
        <cooperation-title-cp
          title="我的合同结算"
          :bg="false"
        ></cooperation-title-cp>
        <van-list
          :offset="30"
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <van-cell v-for="(item, index) in list" :key="index">
            <template>
              <div class="mine-item">
                <mine-accounts-change :item="item"></mine-accounts-change>
                <div class="mine-item-bg"></div>
              </div>
            </template>
          </van-cell>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import cooperationTitleCp from '../components/title-cp';
import mineAccountsChange from './cooperation-packge/components/cooperation-my-accounts-change-cp';
import cooperationSearchHead from './cooperation-packge/components/cooperation-search-head-cp';

import { getUrlParams } from 'common/js/mUtils';

import { Sticky, List, PullRefresh } from 'vant';

export default {
  name: 'cooperation-accounts-index',

  data() {
    return {
      list: [],
      loading: true,
      finished: false,
      refreshing: false,
      current: 1,
      size: 10,
      providerGuid: '',
      body: {},
      companyList: [],
      params: {},
      titleInfo: {
        selectname: '结算日期',
        selectTitle: '结算日期'
      },
      bgUrl: '',
      watertext: '',
      watermobile: ''
    };
  },
  created() {
    let { providerGuid, employeeName, mobile } = getUrlParams();
    this.watertext = decodeURIComponent(employeeName) || '';
    this.watermobile = mobile;
    let params = {
      providerGuid,
      current: this.current,
      size: this.size
    };
    this.providerGuid = providerGuid;
    this._getContractSettleStaistics(params);
    this._getContractSettleList(params);
    this._getComplay({ type: 'settlement' });
    this.$api.getBannerList({ current: 1, size: 999 }).then(res => {
      let { code, body } = res;
      if (code == '0000') {
        let { records } = body;
        records = records.filter(item => item.position == 7);
        this.bgUrl = records.length && records[0].image;
      }
    });
  },
  components: {
    cooperationTitleCp,
    mineAccountsChange,
    cooperationSearchHead,
    [Sticky.name]: Sticky,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh
  },

  methods: {
    _getComplay({ type }) {
      let { providerGuid } = getUrlParams();
      this.$api
        .getCompanyList({
          providerGuid,
          type
        })
        .then(res => {
          let { status, body } = res;
          if (status) {
            this.companyList = body.map(item => {
              return {
                text: item.name,
                value: item.id
              };
            });
          }
        });
    },
    _getContractSettleStaistics(params) {
      this.$api.getContractSettleStaistics(params).then(res => {
        let { status, body } = res;
        if (status) {
          this.body = body;
        }
      });
    },
    _getContractSettleList(params) {
      let { current, providerGuid, size } = this;
      params = { providerGuid, ...params, current, size };
      this.$api.getContractSettleList(params).then(res => {
        let { status, body } = res;
        let { records } = body;
        if (status) {
          this.loading = false;
          this.refreshing = false;
          if (records.length == 0) {
            this.finished = true;
            return;
          }
          this.list = this.list.concat(records);
        }
      });
    },
    handSearch(data) {
      let params = { ...data };
      this.list = [];
      this.current = 1;
      this.params = params;
      this.loading = false;
      this.finished = false;
      this._getContractSettleList(params);
    },
    onLoad() {
      this.current++;
      let { params } = this;
      this._getContractSettleList(params);
    }
  }
};
</script>

<style scoped lang="scss">
.cooperation-accounts-index-container {
  position: relative;
  z-index: 9;
  .accounts-content-head {
    margin-top: 10px;
    .top {
      height: 166px;
      border-bottom: 1px solid #efefef;
      width: 100%;
      display: flex;
      div:nth-child(1) {
        // width: 45%;
        width: 50%;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 30px;
        position: relative;
        span:nth-child(1) {
          color: #36c392;
          font-size: 24px;
          // margin: 0px 0px 20px 0px;x
        }
        span:nth-child(2) {
          margin: 10px 0px 20px 0px;
          color: #000;
          font-size: 32px;
          font-weight: bold;
        }
        span:nth-child(3) {
          color: #666;
          font-size: 24px;
        }
      }
      div:nth-child(1)::after {
        content: '  ';
        width: 1px;
        height: 52px;
        background-color: #f1f1f1;
        margin: 0 auto;
        display: block;
        position: absolute;
        right: 0px;
        top: 74px;
      }
      div:nth-child(2) {
        width: 45%;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 30px;
        position: relative;
        span:nth-child(2) {
          margin: 10px 0px 20px 0px;

          color: #000;
          font-size: 32px;
          font-weight: bold;
        }
        span:nth-child(3) {
          color: #666;
          font-size: 24px;
        }
      }
    }

    .bottom {
      height: 166px;
      width: 100%;
      display: flex;
      div:nth-child(1) {
        // width: 33.33%;
        width: 50%;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 20px;
        position: relative;
        span:nth-child(1) {
          color: #36c392;
          font-size: 24px;
          margin: 0px 0px 20px 0px;
        }
        span:nth-child(2) {
          margin: 10px 0px 20px 0px;
          color: #000;
          font-size: 32px;
          font-weight: bold;
        }
        span:nth-child(3) {
          color: #666;
          font-size: 24px;
        }
      }
      div:nth-child(1)::after {
        content: '  ';
        width: 1px;
        height: 52px;
        background-color: #f1f1f1;
        margin: 0 auto;
        display: block;
        position: absolute;
        right: 0px;
        top: 74px;
      }
      div:nth-child(2),
      div:nth-child(3) {
        // width: 33.33%;
        width: 50%;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 48px;
        position: relative;
        span:nth-child(2) {
          margin-bottom: 20px;
          color: #000;
          font-size: 32px;
          font-weight: bold;
        }
        span:nth-child(3) {
          color: #666;
          font-size: 24px;
        }
      }
      div:nth-child(2)::after {
        // content: '  ';
        // width: 1px;
        // height: 52px;
        // background-color: #f1f1f1;
        // margin: 0 auto;
        // display: block;
        // position: absolute;
        // right: 0px;
        // top: 74px;
      }
    }
  }
  .accounts-body-content {
    margin-top: 20px;
    /deep/ .van-cell {
      position: relative;
      display: flex;
      box-sizing: border-box;
      width: 100%;
      padding: 0px;
      overflow: hidden;
      color: #323233;
      font-size: 0.28rem;
      line-height: 1;
      background-color: transparent;
      margin-bottom: 10px;
    }
    .mine-item {
      background: transparent;
      margin-top: 10px;
      .mine-item-bg {
        background: #efefef;
        height: 10px;
      }
    }
    .mine-item:nth-child(2) {
      margin-top: 0 !important;
    }
  }
}
</style>
